import { render, staticRenderFns } from "./TakeAssessment.vue?vue&type=template&id=76c5471e&scoped=true"
import script from "./TakeAssessment.vue?vue&type=script&lang=js"
export * from "./TakeAssessment.vue?vue&type=script&lang=js"
import style0 from "./TakeAssessment.vue?vue&type=style&index=0&id=76c5471e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5471e",
  null
  
)

export default component.exports